import About from "./components/About";
import Collection from "./components/Collection";
import Contact from "./components/Contact";
import Draw from "./components/Draw";
import Experience from "./components/Experience";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { App_url } from "./utils/constants/static";


export default function App() {
  return (
    <div className="font-sans x-overflow-x-hidden">
      <main className="bg-black">
         <Navbar />
         <About />
         <Collection />
         <Experience />
         <Contact />
         <Draw />
         <Footer />
      </main>
      {/* <footer className="py-12 text-center text-sm text-gray-500">
        Develop | NING HUANG • Design | UN@DSGN
      </footer> */}
    </div>
  );
}
